import React from "react";
import { Helmet } from "react-helmet";
import { makeStyles } from "@material-ui/core/styles";
import { Form } from "./components";
import { SectionHeader, DownloadFooter } from "components/molecules";
import { Section } from "components/organisms";
import { SIGN_UP_SUBTITLE, SIGN_UP_TITLE } from "constants/messages";

const meta = {
  title: "Holler Date | Registration",
  description: "Get started by creating an account with us.",
};

const useStyles = makeStyles((theme) => ({
  root: {},
  formContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: `calc(100vh - ${theme.mixins.toolbar["@media (min-width:600px)"].minHeight}px)`,
    maxWidth: 500,
    margin: `0 auto`,
  },
  section: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

const Register = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
      </Helmet>
      <Section className={classes.section}>
        <div className={classes.formContainer}>
          <SectionHeader
            title={SIGN_UP_TITLE}
            subtitle={SIGN_UP_SUBTITLE}
            titleProps={{
              variant: "h3",
            }}
          />
          <Form />
        </div>
      </Section>
      <DownloadFooter />
    </div>
  );
};

export default Register;
